<script>
import Vue from "vue";
import viewportMixin from "@mixins/viewport";
import { mapState, mapMutations } from "vuex";

// import theme from "./theme";
import styled, { ThemeProvider } from "vue-styled-components";
// import { mapState } from "vuex";

// import NavLink from "./components/NavLink";
import { App, FixedHeader, Section, Center } from "@styled/global";
// import lazyContainerFactory from "@core/lazy-container-factory";
// import { PageHeader, PageTitle, FloatingCTA } from "@/components/index.js";
import "@/components/index.js";

export default {
   mixins: [viewportMixin],
   data() {
      return {
         // Allow viewport async functions to finish before rendering app
         viewportInitialized: false,
      };
   },
   components: {
      ThemeProvider,
   },
   computed: {
      ...mapState("theme", ["theme"]),
      ...mapState("auth", ["user"]),
   },
   async created() {
      console.log("APP - created (start)", this.$store.state.viewport.webp);
      //  const webp = await this.supportsWebp();
      //  console.log("webp", webp);
      const webp = await this.supportsWebp();
      this.setWebp(webp);
      console.log("APP - created webp (end)", this.$store.state.viewport.webp);
      this.viewportInitialized = true;

      console.log("window.devicePixelRatio", window.devicePixelRatio);
   },
   mounted() {
      console.log("APP - mounted", this.$store.state.viewport.webp);
      //  const webp = await this.supportsWebp();
      //  console.log("webp", webp);

      if (this.user) {
         this.setTheme(this.user.theme);
      }
   },
   methods: {
      ...mapMutations("theme", ["setTheme"]),
   },
   render() {
      // Set theme provider from selected theme

      // const theme = this.$store.state.theme;
      // console.log("APP - render", this.viewportInitialized);

      if (this.viewportInitialized === false) {
         return null;
      }

      return (
         <App>
            <ThemeProvider theme={this.theme}>
               <FixedHeader id="fixedHeader" flexDirection="column">
                  <PageHeader copy="mortgage-header" />
                  <PageTitle />
                  <FloatingCTA copy="header-cta" />
               </FixedHeader>
               <Transition name="fade" mode="out-in">
                  <RouterView />
               </Transition>
            </ThemeProvider>
         </App>
      );
   },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";
@import "@/styles/reset-and-normalize.scss";
@import "@/styles/link-reset.scss";
@import "@/styles/button-reset.scss";

body {
   overflow-y: scroll;
   scroll-behavior: smooth;
}

// div.app {
//    padding: 0;
//    margin: 0;
//    font-family: Avenir, Helvetica, Arial, sans-serif;
//    -webkit-font-smoothing: antialiased;
//    -moz-osx-font-smoothing: grayscale;
//    text-align: center;
//    color: #2c3e50;

//    .fade-enter-active,
//    .fade-leave-active {
//       transition-duration: 0.2s;
//       transition-property: opacity;
//       transition-timing-function: ease;
//    }

//    .fade-enter,
//    .fade-leave-active {
//       opacity: 0;
//    }
// }

// #nav {
//    a {
//       font-weight: bold;
//       color: #fff;
//       text-decoration: none;
//       outline: none;
//       margin: 0 10px;

//       &:hover {
//          text-decoration: underline;
//       }

//       &.router-link-exact-active {
//          color: #fff;
//       }
//    }
// }
</style>
